<script setup lang="ts">
import LayoutSide from "~/components/layout/LayoutSide.vue";
import LayoutTop from "~/components/layout/LayoutTop.vue";
import { useUsersStore } from "~/stores/users";

const usersStore = useUsersStore();

await useAsyncData("/users/me", () => usersStore.getMe());
</script>

<template>
	<div class="flex bg-gray-50 min-h-screen">
		<div>
			<LayoutSide />
		</div>
		<div class="w-full">
			<LayoutTop />
			<main class="max-w-[1280px] m-auto p-6 box-content">
				<slot></slot>
			</main>
		</div>
		<CommonModals />
	</div>
</template>
